export default __webpack_public_path__ + "static/media/become-vip.22b93d7c.svg";